<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview>

          <template v-slot:body>
            <div class="row">
              <div class="col-lg-3">
                <div class="menu">
                  <div class="menu-item" :class="{ 'active': position == 'dataPribadi' ? true : false }"
                    @click="goToSection('dataPribadi')">
                    Data Pribadi
                  </div>
                  <div class="menu-item" :class="{ 'active': position == 'akademik' ? true : false }"
                    @click="goToSection('akademik')">
                    Akademik
                  </div>
                  <!-- <div class="menu-item" :class="{ 'active': position == 'alamat' ? true : false }"
                    @click="goToSection('alamat')">
                    Alamat
                  </div> -->
                  <div class="menu-item" :class="{ 'active': position == 'keluarga' ? true : false }"
                    @click="goToSection('keluarga')">
                    Keluarga
                  </div>
                  <div class="menu-item" :class="{ 'active': position == 'wali' ? true : false }"
                    @click="goToSection('wali')">
                    Wali
                  </div>
                  <div class="menu-item" :class="{ 'active': position == 'pendidikan' ? true : false }"
                    @click="goToSection('pendidikan')">
                    Pendidikan
                  </div>
                  <div class="menu-item" :class="{ 'active': position == 'pangkat' ? true : false }"
                    @click="goToSection('pangkat')">
                    Riwayat Pangkat/ Tingkat
                  </div>
                </div>
              </div>
              <div class="col-lg-9">
                <div class="content" ref="dataPribadi">
                  <div class="header-container">
                      <p class="dosen-title">Data Pribadi</p>
                      <div class="button-container">
                        <ButtonComponent name="tambah" :Title="'Edit Profil'" v-b-modal.modal_profile @click.native="ModalProfile('Edit',pribadi)"></ButtonComponent>
                      </div>
                  </div>
                 
                  <hr class="divider-title" />
                  <div class="content-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="row item d-flex justify-content-center mb-6 p-3">
                          <div id="image" class="d-flex justify-content-center flex-column align-items-center">
                            <!-- <div id="preview" style="margin-top: 50%; height: auto;"> -->
                            <div id="preview" class="mb-2">
                              <img v-if="pribadi.portrait" :src="`${pribadi.portrait}`" height="200" width="150" />
                              <div v-else style="height: 200px; width: 150px; background-color: #D9D9D9"></div>
                            </div>
                            <!-- <ButtonComponent style="border: 1px solid #3751E4;" colors="white" name="camera-profil"
                              title="Ganti Foto Profil" dataTitleTooltip="Ganti Foto Profil" /> -->
                          </div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kewarganegaraan</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.student_citizenship }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Agama</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.religion }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Status Perkawinan</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.marital_status }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Alamat</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.alamat }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">RT</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.rt }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">RW</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.rw }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kode Pos</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.postal_code }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kelurahan</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.kelurahan }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kecamatan</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.kecamatan }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kota</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.city }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Provinsi</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.province }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-5 item-title">Nama</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.student_name }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">NIK</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.registration_number }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">NISN</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.nisn }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">NOAK</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.nim }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Jenis Kelamin</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.gender }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Tempat Lahir</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.pob }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Tanggal Lahir</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.dob }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Email</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.student_email }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Nomor Ponsel</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.phone_number }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Golongan Darah</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.blood_type }}
                          </div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Berat Badan</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.weight }} kg</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Tinggi Badan</div>
                          <div class="col-lg-7 item-value">: {{ pribadi.height }} cm</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-modal @ok="onSubmitProfile" ok-title="Simpan" ok-variant="primary" cancel-title="Batal" cancel-variant="danger" 
                    id="modal_profile" :title="`${statusModal} Profil`" >
                    <b-form>
                        <b-form-group label="Nama">
                          <b-form-input type="text" required v-model="request4.student_name" placeholder="Masukan Nama" >
                          </b-form-input>
                        </b-form-group>
                         <b-form-group label="Lampiran" >
                            <b-form-file
                                v-model="potrait"
                                :state="Boolean(potrait)"
                                placeholder="Choose a file"
                                drop-placeholder="Drop file here..."
                                @change="onFileUpload2"
                                ref="file"
                            >
                            </b-form-file>
                        </b-form-group>
                        <b-form-group label="Alamat">
                          <b-form-input type="text" required v-model="request4.streets" placeholder="Masukan Alamat" >
                          </b-form-input>
                        </b-form-group>

                        <b-form-group label="RT">
                          <b-form-input required v-model="request4.RT" placeholder="Masukan RT" >
                          </b-form-input>
                        </b-form-group>

                        <b-form-group label="RW">
                          <b-form-input required v-model="request4.RW" placeholder="Masukan RW" >
                          </b-form-input>
                        </b-form-group>

                          <b-form-group label="Kota / Kabupaten">
                            <b-form-select style="width: 100%;" 
                                           v-model="request4.kota" 
                                           :options="options_kota" 
                                           :changeSelected="changeKota"  >
                            </b-form-select>
                          </b-form-group>

                          <b-form-group label="Kecamatan">
                            <b-form-select style="width: 100%;" v-model="request4.kecamatan" :options="options_kecamatan" :changeSelected="changeKecamatan"  ></b-form-select>
                          </b-form-group>

                          <b-form-group label="Kelurahan">
                            <b-form-select style="width: 100%;" v-model="request4.kelurahan" :options="options_kelurahan" :changeSelected="changeKelurahan"  ></b-form-select>
                          </b-form-group>

                          <b-form-group label="Provinsi">
                            <b-form-select style="width: 100%;" v-model="request4.province" :options="options_province"></b-form-select>
                          </b-form-group>

                          <b-form-group label="Kode Pos">
                          <b-form-input required v-model="request4.kode_pos" placeholder="Masukan Kode Pos" >
                          </b-form-input>
                        </b-form-group>
                     </b-form>
                  </b-modal>
                </div>
                <div class="content" ref="akademik">
                  <p class="dosen-title">Akademik</p>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-5 item-title">Departemen</div>
                          <div class="col-lg-7 item-value">: {{ akademik.department }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Angkatan</div>
                          <div class="col-lg-7 item-value">: {{ akademik.angkatan }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Program Studi</div>
                          <div class="col-lg-7 item-value">: {{ akademik.prodi }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kelas</div>
                          <div class="col-lg-7 item-value">: </div>
                        </div>
                        <div v-if="pribadi.status == 3" class="row item">
                          <div class="col-lg-5 item-title">Penempatan Awal</div>
                          <div class="col-lg-7 item-value">: {{ akademik.penempatan_awal }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-5 item-title">Tanggal Masuk</div>
                          <div class="col-lg-7 item-value">: {{ akademik.tgl_masuk }}</div>
                        </div>
                        
                        <div class="row item">
                          <div class="col-lg-5 item-title">Tahun Akademik</div>
                          <div class="col-lg-7 item-value">: </div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Dosen PA/ Wali</div>
                          <div class="col-lg-7 item-value">: </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- <div class="content" ref="alamat">
                  <p class="dosen-title">Alamat</p>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-5 item-title">Jalan</div>
                          <div class="col-lg-7 item-value">: {{ alamat.streets }}</div>
                        </div>
                        <div class="row">
                          <div class="col-lg-5">
                            <div class="row item">
                              <div class="col-lg-5 item-title">RT</div>
                              <div class="col-lg-7 item-value">: {{ alamat.RT }}</div>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="row item">
                              <div class="col-lg-5 item-title">RW</div>
                              <div class="col-lg-7 item-value">: {{ alamat.RW }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Provinsi</div>
                          <div class="col-lg-7 item-value">: {{ alamat.province }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kota/ Kab</div>
                          <div class="col-lg-7 item-value">: {{ alamat.kota }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kecamatan</div>
                          <div class="col-lg-7 item-value">: {{ alamat.kecamatan }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kelurahan</div>
                          <div class="col-lg-7 item-value">: {{ alamat.kelurahan }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kode Pos</div>
                          <div class="col-lg-7 item-value">: {{ alamat.kode_pos }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
                <div class="content" ref="keluarga">
                  <p class="dosen-title">Keluarga</p>
                  <hr class="divider-title" />
                  <h4 style="font-style: normal; color: #485377; margin-top: 1%;">Ayah</h4>
                  <div class="content-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-5 item-title">Nama</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.name_a }}</div>
                        </div>
                        <!-- <div class="row item">
                          <div class="col-lg-5 item-title">Email</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.email_a }}</div>
                        </div> -->
                        <div class="row item">
                          <div class="col-lg-5 item-title">Tanggal Lahir</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.dob_a }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Alamat</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.address_a }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Pendidikan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.education_a }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Penghasilan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.salary_a }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Pekerjaan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.occupation_a }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-5 item-title">Nomor Ponsel</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.phone_a }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">NIK</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.registration_number_a }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Status Hidup</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.live_state_a }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kab/ Kota</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.city_a }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kewarganegaraan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.citizenship_a }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h4 style="font-style: normal; color: #485377; margin-top: 3%;">Ibu</h4>
                  <div class="content-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-5 item-title">Nama</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.name_b }}</div>
                        </div>
                        <!-- <div class="row item">
                          <div class="col-lg-5 item-title">Email</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.email_b }}</div>
                        </div> -->
                        <div class="row item">
                          <div class="col-lg-5 item-title">Tanggal Lahir</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.dob_b }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Alamat</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.address_b }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Pendidikan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.education_b }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Penghasilan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.salary_b }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Pekerjaan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.occupation_b }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-5 item-title">Nomor Ponsel</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.phone_b }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">NIK</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.registration_number_b }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Status Hidup</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.live_state_b }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kab/ Kota</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.city_b }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kewarganegaraan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.citizenship_b }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content" ref="wali">
                  <p class="dosen-title">Wali</p>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-5 item-title">Nama</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.name_c }}</div>
                        </div>
                        <!-- <div class="row item">
                          <div class="col-lg-5 item-title">Email</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.email_c }}</div>
                        </div> -->
                        <div class="row item">
                          <div class="col-lg-5 item-title">Tanggal Lahir</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.dob_c }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Alamat</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.address_c }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Pendidikan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.education_c }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Penghasilan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.salary_c }}</div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="row item">
                          <div class="col-lg-5 item-title">Nomor Ponsel</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.phone_c }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">NIK</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.registration_number_c }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Status Hidup</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.live_state_c }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kab/ Kota</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.city_c }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Kewarganegaraan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.citizenship_c }}</div>
                        </div>
                        <div class="row item">
                          <div class="col-lg-5 item-title">Pekerjaan</div>
                          <div class="col-lg-7 item-value">: {{ keluarga.occupation_c }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content" ref="pendidikan">
                  <p class="dosen-title">Pendidikan</p>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <v-data-table :headers="pendidikan.headers" :items="pendidikan.desserts">
                      <template v-slot:item.no="{ index }">
                        {{ index + 1 }}.
                      </template>
                      <template v-slot:item.action="{item}">
                        <ButtonComponent name="edit" v-b-modal.modal @click.native="ModalPendidikan('Edit',item)"></ButtonComponent>
                      </template>
                    </v-data-table>
                  </div>
                  <hr class="divider-title" />
                  <div class="button-container">
                    <ButtonComponent name="tambah" :Title="'Tambah Pendidikan'" v-b-modal.modal @click.native="ModalPendidikan('Tambah')"></ButtonComponent>
                  </div>
                  <b-modal @ok="onSubmitPendidikan" ok-title="Simpan" ok-variant="primary" cancel-title="Batal" cancel-variant="danger" 
                    id="modal" :title="`${statusModal} Pendidikan`" >
                    <b-form>
                        <b-form-group label="Nama Judul">
                            <b-form-select style="width: 100%;" v-model="request.degree" :options="options_degree"  ></b-form-select>
                        </b-form-group>
                        <b-form-group label="Nama Institusi">
                            <b-form-input required v-model="request.institute" 
                                placeholder="Masukan nama institusi">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Tahun Kelulusan">
                            <b-form-input required v-model="request.graduation_year" 
                                placeholder="Masukan tahun kelulusan">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Certificate" >
                            <b-form-file
                                v-model="certificate"
                                :state="Boolean(certificate)"
                                placeholder="Choose a file"
                                drop-placeholder="Drop file here..."
                                @change="onFileUpload"
                                ref="file"
                            >
                            </b-form-file>
                        </b-form-group>
                     </b-form>
                </b-modal>  

                </div>
                <div class="content" ref="pangkat">
                  <p class="dosen-title">Pangkat</p>
                  <hr class="divider-title" />

                  <div class="content-body">
                    <v-data-table :headers="pangkat.headers" :items="pangkat.desserts">
                      <template v-slot:item.no="{ index }">
                        {{ index + 1 }}.
                      </template>
                      <template v-slot:item.action="{item}" >
                        <ButtonComponent name="edit" v-b-modal.modal_pangkat @click.native="ModalPangkat('Edit',item)"></ButtonComponent>
                      </template>
                    </v-data-table>
                  </div>
                  <p class="dosen-title">Tingkat</p>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <v-data-table :headers="tingkat.headers" :items="tingkat.desserts">
                      <template v-slot:item.no="{ index }">
                        {{ index + 1 }}.
                      </template>  
                    </v-data-table>
                    <hr class="divider-title" />
                  </div>
                  <div class="button-container">
                    <ButtonComponent name="tambah" :Title="'Tambah Pangkat'" v-b-modal.modal_pangkat @click.native="ModalPangkat('Tambah')"></ButtonComponent>
                  </div>
                  <b-modal @ok="onSubmitPangkat" ok-title="Simpan" ok-variant="primary" cancel-title="Batal" cancel-variant="danger" 
                    id="modal_pangkat" :title="`${statusModal} Pangkat & Tingkat`" >
                    <b-form>
                        <b-form-group label="Pangkat">
                          <b-form-select style="width: 100%;" v-model="request3.pangkat" :options="options_pangkat" @change="changePangkat($event)" ></b-form-select>
                          </b-form-group>
                        <b-form-group label="Tanggal Pengesahan Pangkat">
                            <b-form-datepicker
                              v-model="request3.tanggal_pangkat"
                              required
                              placeholder="Tanggal Pengesahan Pangkat"
                            ></b-form-datepicker>
                        </b-form-group>
                         <b-form-group label="Status Kenaikan Pangkat">
                            <b-form-select style="width: 100%;" v-model="request3.status_pangkat" :options="options_status_pangkat" :changeSelected="changeStatusPangkat"  ></b-form-select>
                          </b-form-group>
                     </b-form>
                  </b-modal>
                </div>
                <div class="content" ref="penempatan">
                  <p class="dosen-title">Riwayat Penempatan Alumni</p>
                  <hr class="divider-title" />
                  <div class="content-body">
                    <v-data-table :headers="header.riwayatPenempatanAdmin" :items="data.riwayatPenempatan">
                    <template v-slot:item.masa="{ item }">
                        {{ item.tahun_awal }} - {{ item.tahun_akhir }}
                    </template>
                     <template v-slot:item.action="{item}" >
                        <ButtonComponent name="edit" v-b-modal.modal_penempatan @click.native="ModalPenempatan('Edit',item)"></ButtonComponent>
                      </template>
                  </v-data-table>
                  </div>
                  <hr class="divider-title" />
                  <div class="button-container">
                    <ButtonComponent name="tambah" :Title="'Tambah Riwayat Penempatan'" v-b-modal.modal_penempatan @click.native="ModalPenempatan('Tambah')"></ButtonComponent>
                  </div>
                  <b-modal @ok="onSubmitPenempatan" ok-title="Simpan" ok-variant="primary" cancel-title="Batal" cancel-variant="danger" 
                    id="modal_penempatan" :title="`${statusModal} Riwayat Penempatan`" >
                    <b-form>
                        <b-form-group label="Satuan Penempatan">
                            <b-form-input
                              v-model="request5.satuan_penempatan"
                              required
                              placeholder="Satuan Penempatan"
                            >
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Jabatan">
                            <b-form-input
                              v-model="request5.jabatan"
                              required
                              placeholder="Jabatan"
                            >
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Pangkat">
                          <b-form-select style="width: 100%;" v-model="request5.pangkat" :options="options_pangkat" @change="changePangkat($event)" ></b-form-select>
                          </b-form-group>
                        <b-form-group label="Tahun Awal">
                            <b-form-input
                              v-model="request5.tahun_awal"
                              required
                              placeholder="Tahun Awal"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group label="Tahun Akhir">
                            <b-form-input
                              v-model="request5.tahun_akhir"
                              required
                              placeholder="Tahun Akhir"
                            ></b-form-input>
                        </b-form-group>
                        
                     </b-form>
                  </b-modal>
                </div>
              </div>
            </div>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>


</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import ButtonComponent from '@/view/content/components/button/buttonComponent.vue';
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
import axios from "axios";


export default {
  data() {
    return {
      key_siswa: null,
      props: this.$route.params.item
        ? JSON.parse(this.$route.params.item)
        : null,
        changePangkat : Function,
      
        
      url: null,
      position: 'dataPribadi',
      pribadi: {
        portrait: null,
        student_name: null,
        registration_number: null,
        nim: null,
        pob: null,
        dob: null,
        status: null,
        student_email: null,
        phone_number: null,
        blood_type: null,
        weight: null,
        height: null,
        student_citizenship: null,
        religion: null,
        marital_status: null,
        gender: null,
        id_user: null,
        awal_penempatan : null,
        nisn            : null,
        key_address     : null,
        alamat          : null,
        rt              : null,
        rw              : null,
        key_city        : null,
        id_kota         : null,
        city            : null,
        key_provinsi    : null,
        province        : null,
        id_kecamatan    : null,
        kecamatan       : null,
        id_kelurahan    : null,
        kelurahan       : null,
        postal_code     : null

      },
      akademik: {
        // nim: null,
        // university: null,
        // faculty_name: null,
        // department_name: null,
        // program_name: null,
        // enrollment_type: null,
        // supervisor: null,
        // initial_financing: null,
        // generation_name: null,
        // phases: null,
        // class_type: null,
        // enrollment_date: null,
        // semester: null,
        // study_field: "t",
        // status: null,
        // batas_studi: null,
        // kelompok: null,
        // nama_dosen: null
        angkatan: null,
        tgl_masuk: null,
        prodi: null,
        department: null,
        fakultas: null,
        nrp: null,
        nim: null,
        name: null,
        penempatan_awal: null,
      },

      alamat: {
        streets: null,
        RT: null,
        RW: null,
        kelurahan: null,
        kecamatan: null,
        kota: null,
        province: null,
        kode_pos: null,
      },
      keluarga: {
        name_a: null,
        email_a: null,
        dob_a: null,
        phone_a: null,
        address_a: null,
        education_a: null,
        city_a: null,
        citizenship_a: null,
        salary_a: null,
        registration_number_a: null,
        occupation_a: null,
        live_state_a: null,
        name_b: null,
        email_b: null,
        dob_b: null,
        phone_b: null,
        address_b: null,
        education_b: null,
        city_b: null,
        citizenship_b: null,
        salary_b: null,
        registration_number_b: null,
        occupation_b: null,
        live_state_b: null,
        name_c: null,
        email_c: null,
        dob_c: null,
        phone_c: null,
        address_c: null,
        education_c: null,
        city_c: null,
        citizenship_c: null,
        salary_c: null,
        registration_number_c: null,
        occupation_c: null,
        live_state_c: null,
      },
      pendidikan: {
        headers: [
          { text: "No", value: "no" },
          { text: "Jenjang Studi" , value: "degree" },
          { text: "Nama Institusi", value: "institute" },
          { text: "Tahun Lulus"   , value: "graduation_year" },
          { text : "Action"        , value : "action"}
        ],
        desserts: [],
      },

      options_pangkat         : [
          {value : null, text : '--Pilih Pangkat--'}
      ],
     
      options_status_pangkat  : [
          {value : 1,text : "Naik"},
          {value : 2,text : "Tetap"}
      ],
      options_status_tingkat  : [
          {value : 1,text : "Naik"},
          {value : 2,text : "Tetap"}
      ],
      tingkat: {
        headers: [
          { text: "No", value: "no" },
          { text: "Tingkat", value: "tingkat" },
          { text: "Tanggal", value: "tanggal_pengesahan_tingkat" },
         
        ],
        desserts: [],
      },
      pangkat: {
        headers: [
          {text : "No"      , value: "no" },
          {text : "Pangkat" , value: "nama_pangkat" },
          {text : "Tanggal Pengesahan Pangkat", value: "tanggal_pengesahan_pangkat" },
          {text : "Action",  value : "action"}
          
        ],
        desserts: [],
      },

      selected : null,
      options_degree: [
        "SD","SMP","SMA","S1","S2"
      ],

      options_tingkat : [
         "Tingkat I",
         "Tingkat II",
         "Tingkat III",
         "Tingkat IV"
      ],

      request : {
          key             : null,
          degree          : null,
          graduation_year : null,
          institute       : null,
          certificate     : null,
      },

      request3 :{
          key             : null,
          status_pangkat  : null,
          pangkat         : null,
          tanggal_pangkat : null,
      },

      request4      : {
          key       : null,
          streets   : null,
          RT        : null,
          RW        : null,
          kelurahan : null,
          kecamatan : null,
          province  : null,
          kota      : null,
          kode_pos  : null,
          student_name : null,
          potrait   : null,

      },

      request5 : {
        key               : null,
        satuan_penempatan : null,
        tahun_awal        : null,
        tahun_akhir       : null,
        pangkat           : null,
        jabatan           : null,
        student           : null
      },

      options_province    : [],
      options_kota        : [],
      options_kecamatan   : [],
      options_kelurahan   : [],

      certificate : null,
      potrait     : null,
      statusModal : null,
      request2: {
        key: null,
        satuan_penempatan: null,
        pangkat: null,
        jabatan: null,
        tahun_awal: null,
        tahun_akhir: null  
      },
      header: {
        riwayatPenempatan: [
          { text: "No", value: "no" },
          { text: "Satuan", value: "satuan" },
          { text: "Pangkat", value: "nama_pangkat" },
          { text: "Jabatan", value: "jabatan" },
          { text: "Masa Tugas", value: "masa" },
          { text: "Aksi", value: "action" },
        ],
        riwayatPenempatanAdmin: [
          { text: "No", value: "no" },
          { text: "Satuan", value: "satuan" },
          { text: "Pangkat", value: "nama_pangkat" },
          { text: "Jabatan", value: "jabatan" },
          { text: "Masa Tugas", value: "masa" },
          { text: "Aksi", value: "action" },
        ]
      },
      data: {
        riwayatPenempatan: [],
      }
    }
  },
  components: {
    KTCodePreview,
    ButtonComponent
  },
  methods: {
    goToSection(value) {
      let element = this.$refs[value];
      let top = element.offsetTop;
      this.position = value
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
    },

    changeStatusPangkat(selected){
        this.request3.status_pangkat = selected;
    },
    
    
  

    async getCity(){
      await axios.get('master/cities').then(response => {
            if(response.status == 200){
                response.data.data.some( (e) => {
                      var obj = {
                          value : e.id_kabupaten,
                          text  : e.nama_kabupaten
                      }

                    this.options_kota.push(obj);
                })
            }
      })

    },  
    
    

    async getProvince(){
      await axios.get('master/province').then(response => {
          if(response.status == 200){
            response.data.data.some( (e) => {
                var obj = {
                    value : e.key,
                    text : e.nama_provinsi
                }
                this.options_province.push(obj);
            })
          }
      })
    },

    async getKecamatan(){
      await axios.get('master/subdistricts').then(response => {
            if(response.status == 200){
                response.data.data.some( (e) => {
                    var obj = {
                        value : e.id,
                        text : e.name
                    }

                    this.options_kecamatan.push(obj);
                })
            }
      })
    },

    async getKecamatanByCity(){

        if(this.options_kecamatan.length > 0){
            this.options_kecamatan = [];
        }

        await axios.get(`master/subdistricts/${this.request4.kota}`).then(response => {
            if(response.status == 200){
                response.data.data.some( (e) => {
                    var obj = {
                    value : e.id_kec,
                    text   : e.nama_kecamatan
                  }
                this.options_kecamatan.push(obj);
              })
               
            }
        })
    },

    async getKelurahan(){
      await axios.get('master/wards').then(response => {
          if(response.status == 200){
              response.data.data.some( (e) => {
                  var obj = {
                    value : e.id,
                    text    : e.name
                  }

                  this.options_kelurahan.push(obj);
              })
          }
      })


    },

    ModalPendidikan(status, itemData = null){
        this.statusModal = status;
        this.request = {
            key             : null,
            degree          : null,
            graduation_year : null,
            institute       : null,
            certificate     : null,
        }

        if(status == 'Edit'){
            this.request.key              = itemData.key
            this.request.degree           = itemData.degree
            this.request.graduation_year  = itemData.graduation_year
            this.request.institute        = itemData.institute
            this.request.certificate      = itemData.certificate
        }
    },

    ModalPenempatan(status,itemData = null ){
      this.statusModal = status;

      this.request5 = {    
        key               : null,
        satuan_penempatan : null,
        tahun_awal        : null,
        tahun_akhir       : null,
        pangkat           : null,
        jabatan           : null,
        student           : null
      }

      if(status == 'Edit'){
        this.request5.key               = itemData.key;
        this.request5.satuan_penempatan = itemData.satuan;
        this.request5.tahun_awal        = itemData.tahun_awal;
        this.request5.tahun_akhir       = itemData.tahun_akhir;
        this.request5.pangkat           = itemData.key_pangkat;
        this.request5.jabatan           = itemData.jabatan;


      }
    },

    ModalProfile(status, itemData = null){
      this.statusModal = status;
      if(status == 'Edit'){
        this.request4.key       = itemData.key_address;
        this.request4.streets   = itemData.alamat;
        this.request4.RT        = itemData.rt;
        this.request4.RW        = itemData.rw;
        this.request4.kelurahan = itemData.id_kelurahan;
        this.request4.kecamatan = itemData.id_kecamatan;
        this.request4.kota      = itemData.id_kota;
        this.request4.province  = itemData.key_provinsi;
        this.request4.kode_pos  = itemData.postal_code;
        this.request4.student_name  = itemData.student_name;
      }
    },

    ModalPangkat(status, itemData = null){
        this.statusModal = status;
        this.request3 = {
          key             : null,
          status_pangkat  : null,
          pangkat         : null,
          tanggal_pangkat : null,
          
        }

        if(status == 'Edit'){
            this.request3.key             = itemData.key;
            this.request3.status_pangkat  = itemData.status_pangkat;
            this.request3.pangkat         = itemData.pangkat;
            this.request3.tanggal_pangkat = itemData.tanggal_pengesahan_pangkat;
        }
    },

    async storePangkat(form){

        try{

             this.key_siswa = JSON.parse(localStorage.getItem('dataLogin')).key_siswa

            const formData = {
              status_pangkat  : form.status_pangkat,
              pangkat         : form.pangkat,
              tanggal_pangkat : form.tanggal_pangkat,
             
            }
            const result = await axios.post(`master/promotion/alumni/${this.key_siswa}`,formData);
            this.refreshDataPangkat(result,'Store')

        }catch(err){
          this.$swal(`Failed`);
        }
    },

    async storePenempatan(form){

        try{
          this.key_siswa = JSON.parse(localStorage.getItem('dataLogin')).key_siswa
          const formData = {
            satuan_penempatan : form.satuan_penempatan,
            tahun_awal        : form.tahun_awal,
            tahun_akhir       : form.tahun_akhir,
            jabatan           : form.jabatan,
            pangkat           : form.pangkat,
            student           : this.key_siswa
          }

          const result = await axios.post(`alumni-new/riwayat-penempatan/save`,formData);
          this.refreshDataPenempatan(result,'Store');

        }catch(err){
          this.$swal(`Failed`);
        }
    },

    async updatePenempatan(form){
        try{

          this.key_siswa = JSON.parse(localStorage.getItem('dataLogin')).key_siswa
          const formData = {
            key               : form.key,
            satuan_penempatan : form.satuan_penempatan,
            tahun_awal        : form.tahun_awal,
            tahun_akhir       : form.tahun_akhir,
            jabatan           : form.jabatan,
            pangkat           : form.pangkat,
            student           : this.key_siswa
          }

          const result = await axios.put(`alumni-new/riwayat-penempatan/update/${form.key}`,formData);
          this.refreshDataPenempatan(result,'Update');

        }catch(err){
          this.$swal(`Failed`);
        }
    },

    async updatePangkat(form){
      try{

        this.key_siswa = JSON.parse(localStorage.getItem('dataLogin')).key_siswa

          const formData = {
              key : form.key,
              status_pangkat  : form.status_pangkat,
              pangkat         : form.pangkat,
              tanggal_pangkat : form.tanggal_pangkat,
              
          }

          const result = await axios.put(`master/promotion/alumni/${this.key_siswa}/${form.key}`,formData);
          this.refreshDataPangkat(result,'Update');

      }catch(err){ 
          this.$swal(`Failed`);
      }

    },

    async updateAlamat(form){
      try{

        this.key_siswa = JSON.parse(localStorage.getItem('dataLogin')).key_siswa

        const formData = new FormData();

        formData.append('streets',form.streets);
        formData.append('RT',form.RT);
        formData.append('RW',form.RW);
        formData.append('kelurahan',form.kelurahan);
        formData.append('kecamatan',form.kecamatan);
        formData.append('kota',form.kota);
        formData.append('province',form.province);
        formData.append('kode_pos',form.kode_pos);
        formData.append('student_name',form.student_name);
        formData.append('potrait',this.potrait);



        const result = await axios.post(`master/student-address/${this.key_siswa}`,formData,
          {
            headers : {
              'Content-type' : 'multipart/form-data'
            }
          }
        );
        this.refreshDataAddress(result,'Update');

      }catch(err){
        this.$swal(`Failed`);
      }
    },

    async getPangkatDropdown(){
         await axios.get('master/rank').then(response => {

             if(response.status == 200){
                response.data.data.some( (e) => {
                    var object = {
                       value    : e.key,
                       text   : e.rank
                    }

                    this.options_pangkat.push(object);
                })
             }
         })
    },



    async storePendidikan(form){
      const formData = new FormData();

      formData.append('certificate',this.certificate);
      formData.append('degree',form.degree);
      formData.append('graduation_year',form.graduation_year);
      formData.append('institute',form.institute);

      const result = await axios.post(`master/student-education/${this.key_siswa}`,formData,{
          headers : {
            'Content-type' : 'multipart/form-data'
          }
      });
      this.refreshDataPendidikan(result,'Store');
    }, 

   
    

    async updatePendidikan(form){
      const formData = new FormData();

      formData.append('certificate',this.certificate);
      formData.append('degree',form.degree);
      formData.append('graduation_year',form.graduation_year);
      formData.append('institute',form.institute);

      const result = await axios.post(`master/student-education/update/${form.key}`,formData,{
          headers : {
            'Content-type' : 'multipart/form-data'
          }
      });

      this.refreshDataPendidikan(result,'Update');

    },

    async onSubmitPendidikan(){
        const form = this.request;
        if(form.key === null){
            this.storePendidikan(form);
        }else{
          this.updatePendidikan(form);
        }
    },

    async onSubmitPangkat(){
        const form = this.request3;
        if(form.key === null){
            this.storePangkat(form);
        }else{
            this.updatePangkat(form);
        }
    },

    async onSubmitProfile(){
        const form = this.request4;
        this.updateAlamat(form);
    },

    async onSubmitPenempatan(){
       const form = this.request5;
       if(form.key === null){
          this.storePenempatan(form);
       }else{
        this.updatePenempatan(form);
       }
    },

    refreshDataPendidikan(result,alert){
      if(result.data.meta.code == 200){
          this.$swal({
            title: `Success ${alert} data`,
              buttons: {
                confirm: {
                  text: 'OK',
                  value: true,
                  visible: true,
                  className: 'swal-ok-btn',
                },
              },
          })

          this.getDataPendidikan()
      }
      else if(result.data.meta.code == 500){
        this.$swal({
          title: `${alert}`, 
                buttons: {
                  confirm: {
                  text: 'Failed',
                  value: true,
                  visible: true,
                  className: 'swal-failed-btn',
                  },
                },
              })
        }

    },

    refreshDataPangkat(result,alert){
      if(result.data.meta.code == 200){
          this.$swal({
            title: `Success ${alert} data`,
              buttons: {
                confirm: {
                  text: 'OK',
                  value: true,
                  visible: true,
                  className: 'swal-ok-btn',
                },
              },
          })

          this.getPangkat();
          // this.getTingkat();
      }
      else if(result.data.meta.code == 500){
        this.$swal({
          title: `${alert}`, 
                buttons: {
                  confirm: {
                  text: 'Failed',
                  value: true,
                  visible: true,
                  className: 'swal-failed-btn',
                  },
                },
              })
        }

    },

    refreshDataPenempatan(result,alert){
      if(result.data.meta.code == 200){
        this.$swal({
            title: `Success ${alert} data`,
              buttons: {
                confirm: {
                  text: 'OK',
                  value: true,
                  visible: true,
                  className: 'swal-ok-btn',
                },
              },
          })

          this.getPenempatan();

      }
      else if(result.data.meta.code == 500){
        this.$swal({
          title: `${alert}`, 
                buttons: {
                  confirm: {
                  text: 'Failed',
                  value: true,
                  visible: true,
                  className: 'swal-failed-btn',
                  },
                },
              })
      }

    },

    refreshDataAddress(result,alert){
      if(result.data.meta.code == 200){
        this.$swal({
            title: `Success ${alert} data`,
              buttons: {
                confirm: {
                  text: 'OK',
                  value: true,
                  visible: true,
                  className: 'swal-ok-btn',
                },
              },
          })

          this.getDataDiri();

      }
      else if(result.data.meta.code == 500){
        this.$swal({
          title: `${alert}`, 
                buttons: {
                  confirm: {
                  text: 'Failed',
                  value: true,
                  visible: true,
                  className: 'swal-failed-btn',
                  },
                },
              })
      }

    },



    onFileUpload(event) {
      const file = event.target.files[0];
        if(file){
            this.fileName = file.name;
            this.certificate = file;
          
        }
      },

      onFileUpload2(event){
          const file = event.target.files[0];
          if(file){
            this.fileName = file.name;
             this.potrait = file;

          }
      },

    async getDataPendidikan(){    
      // data pendidikan
      this.key_siswa = JSON.parse(localStorage.getItem('dataLogin')).key_siswa
      const result_education = await axios.get(`master/student-education/${this.key_siswa}/detail-by-student-id`);
      
      if (result_education.data.meta.code == 200) {

        if(this.pendidikan.desserts.length > 0){
          this.pendidikan.desserts = [];
        }
        this.pendidikan.desserts = result_education.data.data
      }
    },

    async getPangkat(){
      this.key_siswa = JSON.parse(localStorage.getItem('dataLogin')).key_siswa

      await axios.get(`master/promotion/${this.key_siswa}/student`).then(response => {
          if(response.status == 200){
            
            if(this.pangkat.desserts.length > 0){
                this.pangkat.desserts = [];
            }

            if(this.tingkat.desserts.length > 0){
                this.tingkat.desserts = [];
            }

  
                  response.data.data.some( (e,index) => {
                    var riwayat_pa = {
                      no                          : index + 1, 
                      key                         : e.promotion_key,
                      nama_pangkat                : e.nama_pangkat, 
                      pangkat                     : e.key_pangkat,
                      tanggal_pengesahan_pangkat  : e.tanggal_pengesahan_pangkat,
                      status_pangkat              : e.status_kenaikan_pangkat,
                    }

                    this.pangkat.desserts.push(riwayat_pa);

                    if(e.tingkat !== null ){
                        var riwayat_ti ={
                          no                          : index + 1, 
                          key                         : e.promotion_key,
                          tingkat                     : e.tingkat,
                          tanggal_pengesahan_tingkat  : e.tanggal_pengesahan_tingkat,
                          status_tingkat              : e.status_kenaikan_tingkat
                        }

                      this.tingkat.desserts.push(riwayat_ti);
                    }
                    
                })
           
          }
      })

    },

    async getTingkat(){

      this.key_siswa = JSON.parse(localStorage.getItem('dataLogin')).key_siswa

      await axios.get(`master/promotion/${this.key_siswa}/student`).then(response => {
          if(response.status == 200){

              if(this.tingkat.desserts.length > 0){
                  this.tingkat.desserts = [];
              }


              if(Array.isArray(response.data.data)){
                  response.data.data.some( (e,index)  => {
                    var riwayat_t = {
                        no                        : index + 1, 
                        tingkat                   : e.tingkat, 
                        tanggal_pengesahan_tingkat: e.tanggal_pengesahan_tingkat
                      }

                      this.tingkat.desserts.push(riwayat_t);
                  })
              }else{

                  var riwayat_t = {
                      no : 1,
                      tingkat : response.data.data.tingkat,
                      tanggal_pengesahan_tingkat : response.data.data.tanggal_pengesahan_tingkat
                  }

                  this.tingkat.desserts.push(riwayat_t);
              }
          }
      });
    },

    async getPenempatan(){
      // data penempatan

      this.key_siswa = JSON.parse(localStorage.getItem('dataLogin')).key_siswa

      await axios.get(`alumni-new/riwayat-penempatan/${this.key_siswa}`).then(response => {

        if(response.status == 200){

            if(this.data.riwayatPenempatan.length > 0){
                this.data.riwayatPenempatan = [];
            }

            if(Array.isArray(response.data.data)){

                response.data.data.some( (e,index) => {

                    var object = {

                        no            : index + 1,
                        key           : e.key,
                        satuan        : e.satuan_penempatan,
                        key_pangkat   : e.key_pangkat,
                        nama_pangkat  : e.nama_pangkat,
                        jabatan       : e.jabatan,
                        tahun_awal    : e.tahun_awal,
                        tahun_akhir   : e.tahun_akhir
                    }

                    this.data.riwayatPenempatan.push(object);                    

                } )
            }else{

                var object = {
                   no           : 1,
                   key          : response.data.data.key,
                   satuan       : response.data.data.satuan_penempatan,
                   key_pangkat  : response.data.data.key_pangkat,
                   nama_pangkat : response.data.data.nama_pangkat,
                   jabatan      : response.data.data.jabatan,
                   tahun_awal   : response.data.data.tahun_awal,
                   tahun_akhir  : response.data.data.tahun_akhir
                }

                this.data.riwayatPenempatan.push(object);
            }
        }

      })
    },

    async getDataDiri(){
        var result = await axios.get(`master/student/${this.uuid_siswa}/detail`);

        if(this.uuid_siswa == undefined) {
          this.key_siswa = JSON.parse(localStorage.getItem('dataLogin')).key_siswa
          
          result = await axios.get(`master/student/${this.key_siswa}/detail`);
        }


        // data pribadi
        this.pribadi.portrait   = null;
        this.pribadi.student_name = null;
        this.pribadi.registration_number = null;
        this.pribadi.pob        = null;
        this.pribadi.dob        = null;
        this.pribadi.nim        = null;
        this.pribadi.nisn       = null;
        this.pribadi.status     = null;
        this.pribadi.id_user    = null;
        this.pribadi.alamat     = null;
        this.pribadi.rt         = null;
        this.pribadi.rw         = null;
        this.pribadi.key_city   = null;
        this.pribadi.id_kota    = null;
        this.pribadi.city       = null;
        this.pribadi.key_provinsi     = null;
        this.pribadi.key_provinsi     = null;
        this.pribadi.province         = null;
        this.pribadi.id_kecamatan     = null;
        this.pribadi.kecamatan        = null;
        this.pribadi.id_kelurahan     = null;
        this.pribadi.kelurahan        = null;
        this.pribadi.awal_penempatan  = null;
        this.pribadi.student_email    = null;
        this.pribadi.phone_number     = null;
        this.pribadi.blood_type       = null;
        this.pribadi.weight = null;
        this.pribadi.height = null;
        this.pribadi.student_citizenship = null;
        this.pribadi.religion = null;
        this.pribadi.marital_status = null;
        this.pribadi.postal_code    = null;

        if (result.data.data.portrait != "") {
          this.pribadi.portrait = this.$endpoint + 'uploads/student_portrait/' + result.data.data.portrait
        }
        this.pribadi.student_name = result.data.data.student_name
        this.pribadi.registration_number = result.data.data.registration_number
        this.pribadi.pob = result.data.data.pob
        const [year, month, day] = result.data.data.dob.split('-');
        const formatted = `${day}-${month}-${year}`;
        this.pribadi.dob = formatted
        this.pribadi.nim = result.data.data.nim
        this.pribadi.nisn = result.data.data.nisn
        this.pribadi.status = result.data.data.status
        this.pribadi.awal_penempatan = result.data.data.awal_penempatan
        this.pribadi.student_email = result.data.data.student_email
        this.pribadi.phone_number = result.data.data.phone_number
        this.pribadi.blood_type = result.data.data.blood_type
        if (this.pribadi.blood_type == 'a') {
          this.pribadi.blood_type = 'A'
        } else if (this.pribadi.blood_type == 'b') {
          this.pribadi.blood_type = 'B'
        } else if (this.pribadi.blood_type == 'o') {
          this.pribadi.blood_type = 'O'
        } else if (this.pribadi.blood_type == 'ab') {
          this.pribadi.blood_type = 'AB'
        }
        this.pribadi.weight = result.data.data.weight
        this.pribadi.height = result.data.data.height
        this.pribadi.student_citizenship = result.data.data.student_citizenship
        this.pribadi.religion = result.data.data.religion_name
        // const result_religion = await axios.get(`master/religion/${this.pribadi.religion}/detail`);
        // this.pribadi.religion = result_religion.data.data.religion_name
        this.pribadi.marital_status = result.data.data.marital_status
        if (this.pribadi.marital_status == 'single') {
          this.pribadi.marital_status = 'Belum Menikah'
        } else if (this.pribadi.marital_status == 'married') {
          this.pribadi.marital_status = 'Menikah'
        }
        this.pribadi.gender = result.data.data.gender
        if (this.pribadi.gender == 'L') {
          this.pribadi.gender = 'Laki-laki'
        } else if (this.pribadi.gender == 'P') {
          this.pribadi.gender = 'Perempuan'
        }
        this.pribadi.id_user = result.data.data.id_user

        this.pribadi.alamat       = result.data.data.streets;
        this.pribadi.key_address  = result.data.data.key_address;
        this.pribadi.rt           = result.data.data.RT;
        this.pribadi.rw           = result.data.data.RW;
        this.pribadi.city         = result.data.data.nama_kabupaten;
        this.pribadi.id_kota      = result.data.data.id_kabupaten;
        this.pribadi.key_city     = result.data.data.key_kabupaten;
        this.pribadi.province     = result.data.data.nama_provinsi;
        this.pribadi.key_provinsi = result.data.data.key_provinsi;
        this.pribadi.id_kecamatan = result.data.data.id_kecamatan;
        this.pribadi.kecamatan    = result.data.data.nama_kecamatan;
        this.pribadi.id_kelurahan = result.data.data.id_kelurahan;
        this.pribadi.kelurahan    = result.data.data.nama_kelurahan;
        this.pribadi.postal_code  = result.data.data.postal_code;
      },

    
  },
  computed: {
    uuid_siswa() {
      return this.$route.params != null ? this.$route.params.key : null
    }
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Alumni", route: "/students/student-list" },
      { title: "Lihat Detail Alumni" },
    ]),

    this.getDataPendidikan(),
    this.getPangkat(),
    this.getPenempatan(),
    this.getPangkatDropdown(),
    this.getDataDiri(),
    this.getProvince(),
    this.getCity(),
    this.getKecamatan(),
    this.getKecamatanByCity();
    this.getKelurahan()
    
    // data akademik old
    // const result_academic = await axios.get(`master/student-academic-detail/${result.data.data.key}/detail-by-student-id`);
    // if (result_academic.data.data != null) {
    //   this.akademik.nim = result_academic.data.data.nim
    //   this.akademik.university = result_academic.data.data.university
    //   this.akademik.faculty_name = result_academic.data.data.faculty_name
    //   this.akademik.department_name = result_academic.data.data.department_name
    //   this.akademik.program_name = result_academic.data.data.program_name
    //   this.akademik.enrollment_type = result_academic.data.data.enrollment_type
    //   this.akademik.supervisor = result_academic.data.data.supervisor
    //   this.akademik.initial_financing = result_academic.data.data.initial_financing
    //   var number_string = this.akademik.initial_financing.replace(/[^,\d]/g, '').toString()
    //   var split = number_string.split(',')
    //   var sisa = split[0].length % 3
    //   var rupiah = split[0].substr(0, sisa)
    //   var ribuan = split[0].substr(sisa).match(/\d{3}/gi);
    //   if (ribuan) {
    //     var separator = sisa ? '.' : '';
    //     rupiah += separator + ribuan.join('.');
    //   }
    //   this.akademik.initial_financing = rupiah
    //   this.akademik.generation_name = result_academic.data.data.generation_year + " / " + result_academic.data.data.tahun_akhir + " - " + result_academic.data.data.generation_semester
    //   this.akademik.phases = result_academic.data.data.phases
    //   this.akademik.class_type = result_academic.data.data.class_type
    //   if (this.akademik.class_type == 'kelas1') {
    //     this.akademik.class_type = 'Kelas 1'
    //   } else if (this.akademik.class_type == 'kelas2') {
    //     this.akademik.class_type = 'Kelas 2'
    //   } else if (this.akademik.class_type == 'kelas3') {
    //     this.akademik.class_type = 'Kelas 3'
    //   } else if (this.akademik.class_type == 'kelas4') {
    //     this.akademik.class_type = 'Kelas 4'
    //   }
    //   this.akademik.enrollment_date = result_academic.data.data.enrollment_date
    //   let date = new Date(this.akademik.enrollment_date)
    //   let day = date.getDate()
    //   let month = date.getMonth() + 1
    //   let year = date.getFullYear()
    //   this.akademik.enrollment_date = day + "/" + month + "/" + year
    //   this.akademik.semester = result_academic.data.data.semester
    //   this.akademik.study_field = result_academic.data.data.study_field
    //   this.akademik.status = result.data.data.status
    //   this.akademik.batas_studi = result_academic.data.data.batas_studi
    //   this.akademik.kelompok = result.data.data.nama_kelompok
    //   this.akademik.nama_dosen = result_academic.data.data.nama_dosen
    // }

        var result = await axios.get(`master/student/${this.uuid_siswa}/detail`);

    if(this.uuid_siswa == undefined) {
      this.key_siswa = JSON.parse(localStorage.getItem('dataLogin')).key_siswa
      
      result = await axios.get(`master/student/${this.key_siswa}/detail`);
    }


    //data akademik
    const result_academic = await axios.get(`alumni-new/data-akademik/${result.data.data.key}`);
    if (result_academic.data.data != null) {
      this.akademik.angkatan = result_academic.data.data.angkatan;
      const [year_akademik, month_akademik, day_akademik] = result_academic.data.data.tgl_masuk.split('-');
      const formatted_akademik = `${day_akademik}-${month_akademik}-${year_akademik}`;
      this.akademik.tgl_masuk = formatted_akademik;
      this.akademik.prodi = result_academic.data.data.prodi;
      this.akademik.department = result_academic.data.data.departemen;
      this.akademik.fakultas = result_academic.data.data.fakultas;
      this.akademik.nrp = result_academic.data.data.nrp;
      this.akademik.nim = result_academic.data.data.nim;
      this.akademik.name = result_academic.data.data.name;
    }
    // data alamat
    // const result_address = await axios.get(`master/student-address/${result.data.data.key}/detail-by-student-id`);
    // if (result_address) {
    //   this.alamat.streets = result_address.data.data.streets
    //   this.alamat.RT = result_address.data.data.RT
    //   this.alamat.RW = result_address.data.data.RW
    //   this.alamat.kelurahan = result_address.data.data.nama_desa_kelurahan
    //   this.alamat.kecamatan = result_address.data.data.nama_kecamatan
    //   this.alamat.kota = result_address.data.data.nama_kab_kota
    //   this.alamat.province = result_address.data.data.nama_provinsi
    //   this.alamat.kode_pos = result_address.data.data.kode_pos
    // }

    // data keluarga & wali
    const result_guardian = await axios.get(`master/student-guardian/${result.data.data.key}/detail-by-student-id`);
    if (result_guardian) {
      for (var i = 0; i < result_guardian.data.data.length; i++) {
        if (result_guardian.data.data[i].type == 1) {
          this.keluarga.name_a = result_guardian.data.data[i].name
          this.keluarga.email_a = result_guardian.data.data[i].email
          this.keluarga.dob_a = result_guardian.data.data[i].dob
          let date = new Date(this.keluarga.dob_a)
          let day = date.getDate()
          let month = date.getMonth() + 1
          let year = date.getFullYear()
          // this.keluarga.dob_a = day + "/" + month + "/" + year
          this.keluarga.dob_a = day + "-" + month + "-" + year
          this.keluarga.phone_a = result_guardian.data.data[i].phone
          this.keluarga.address_a = result_guardian.data.data[i].address
          this.keluarga.education_a = result_guardian.data.data[i].education
          this.keluarga.city_a = result_guardian.data.data[i].nama_kab_kota
          this.keluarga.citizenship_a = result_guardian.data.data[i].citizenship
          this.keluarga.salary_a = result_guardian.data.data[i].salary
          if (this.keluarga.salary_a == 'p1') {
            this.keluarga.salary_a = '< Rp. 1.000.000'
          } else if (this.keluarga.salary_a == 'p2') {
            this.keluarga.salary_a = 'Rp. 1.000.000 - Rp. 5.000.000'
          } else if (this.keluarga.salary_a == 'p3') {
            this.keluarga.salary_a = 'Rp. 5.000.000 - Rp. 10.000.000'
          } else if (this.keluarga.salary_a == 'p4') {
            this.keluarga.salary_a = '> Rp. 10.000.000'
          }
          this.keluarga.registration_number_a = result_guardian.data.data[i].registration_number
          this.keluarga.occupation_a = result_guardian.data.data[i].occupation
          if (this.keluarga.occupation_a == 'pe1') {
            this.keluarga.occupation_a = 'Pegawai Negeri'
          } else if (this.keluarga.occupation_a == 'pe2') {
            this.keluarga.occupation_a = 'Pegawai Swasta'
          } else if (this.keluarga.occupation_a == 'pe3') {
            this.keluarga.occupation_a = 'Dokter'
          } else if (this.keluarga.occupation_a == 'pe4') {
            this.keluarga.occupation_a = 'Freelance'
          }
          this.keluarga.live_state_a = result_guardian.data.data[i].live_state
          if (this.keluarga.live_state_a == 's1') {
            this.keluarga.live_state_a = 'Hidup'
          } else {
            this.keluarga.live_state_a = 'Meninggal'
          }
        } else if (result_guardian.data.data[i].type == 2) {
          this.keluarga.name_b = result_guardian.data.data[i].name
          this.keluarga.email_b = result_guardian.data.data[i].email
          this.keluarga.dob_b = result_guardian.data.data[i].dob
          let date = new Date(this.keluarga.dob_b)
          let day = date.getDate()
          let month = date.getMonth() + 1
          let year = date.getFullYear()
          // this.keluarga.dob_b = day + "/" + month + "/" + year
          this.keluarga.dob_b = day + "-" + month + "-" + year
          this.keluarga.phone_b = result_guardian.data.data[i].phone
          this.keluarga.address_b = result_guardian.data.data[i].address
          this.keluarga.education_b = result_guardian.data.data[i].education
          this.keluarga.city_b = result_guardian.data.data[i].nama_kab_kota
          this.keluarga.citizenship_b = result_guardian.data.data[i].citizenship
          this.keluarga.salary_b = result_guardian.data.data[i].salary
          if (this.keluarga.salary_b == 'p1') {
            this.keluarga.salary_b = '< Rp. 1.000.000'
          } else if (this.keluarga.salary_b == 'p2') {
            this.keluarga.salary_b = 'Rp. 1.000.000 - Rp. 5.000.000'
          } else if (this.keluarga.salary_b == 'p3') {
            this.keluarga.salary_b = 'Rp. 5.000.000 - Rp. 10.000.000'
          } else if (this.keluarga.salary_b == 'p4') {
            this.keluarga.salary_b = '> Rp. 10.000.000'
          }
          this.keluarga.registration_number_b = result_guardian.data.data[i].registration_number
          this.keluarga.occupation_b = result_guardian.data.data[i].occupation
          if (this.keluarga.occupation_b == 'pe1') {
            this.keluarga.occupation_b = 'Pegawai Negeri'
          } else if (this.keluarga.occupation_b == 'pe2') {
            this.keluarga.occupation_b = 'Pegawai Swasta'
          } else if (this.keluarga.occupation_b == 'pe3') {
            this.keluarga.occupation_b = 'Dokter'
          } else if (this.keluarga.occupation_b == 'pe4') {
            this.keluarga.occupation_b = 'Freelance'
          }
          this.keluarga.live_state_b = result_guardian.data.data[i].live_state
          if (this.keluarga.live_state_b == 's1') {
            this.keluarga.live_state_b = 'Hidup'
          } else {
            this.keluarga.live_state_b = 'Meninggal'
          }
        } else if (result_guardian.data.data[i].type == 3) {
          this.keluarga.name_c = result_guardian.data.data[i].name
          this.keluarga.email_c = result_guardian.data.data[i].email
          this.keluarga.dob_c = result_guardian.data.data[i].dob
          let date = new Date(this.keluarga.dob_c)
          let day = date.getDate()
          let month = date.getMonth() + 1
          let year = date.getFullYear()
          this.keluarga.dob_c = day + "-" + month + "-" + year
          this.keluarga.phone_c = result_guardian.data.data[i].phone
          this.keluarga.address_c = result_guardian.data.data[i].address
          this.keluarga.education_c = result_guardian.data.data[i].education
          this.keluarga.city_c = result_guardian.data.data[i].nama_kab_kota
          this.keluarga.citizenship_c = result_guardian.data.data[i].citizenship
          this.keluarga.salary_c = result_guardian.data.data[i].salary
          if (this.keluarga.salary_c == 'p1') {
            this.keluarga.salary_c = '< Rp. 1.000.000'
          } else if (this.keluarga.salary_c == 'p2') {
            this.keluarga.salary_c = 'Rp. 1.000.000 - Rp. 5.000.000'
          } else if (this.keluarga.salary_c == 'p3') {
            this.keluarga.salary_c = 'Rp. 5.000.000 - Rp. 10.000.000'
          } else if (this.keluarga.salary_c == 'p4') {
            this.keluarga.salary_c = '> Rp. 10.000.000'
          }
          this.keluarga.registration_number_c = result_guardian.data.data[i].registration_number
          this.keluarga.occupation_c = result_guardian.data.data[i].occupation
          if (this.keluarga.occupation_c == 'pe1') {
            this.keluarga.occupation_c = 'Pegawai Negeri'
          } else if (this.keluarga.occupation_c == 'pe2') {
            this.keluarga.occupation_c = 'Pegawai Swasta'
          } else if (this.keluarga.occupation_c == 'pe3') {
            this.keluarga.occupation_c = 'Dokter'
          } else if (this.keluarga.occupation_c == 'pe4') {
            this.keluarga.occupation_c = 'Freelance'
          }
          this.keluarga.live_state_c = result_guardian.data.data[i].live_state
          if (this.keluarga.live_state_c == 's1') {
            this.keluarga.live_state_c = 'Hidup'
          } else {
            this.keluarga.live_state_c = 'Meninggal'
          }
        }
      }
    }
  },

  

}
</script>
<style lang="scss">
.menu-item.active {
  background-color: #3751E4;
  color: white;
  padding: 10px;
  border-radius: 7px;
  cursor: pointer;
}

.header-container {
  display: flex;
  align-items: center; /* Agar tulisan dan button berada di tengah secara vertikal */
  justify-content: space-between; /* Agar button berada di ujung kanan */
}

.button-container{
  margin-top: 8px;
  text-align: right;
}

.menu-item {
  padding: 10px;
  border-radius: 7px;
  cursor: pointer;
}

.dosen-title {
  // font-family: 'Outfit';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 19px;
  /* identical to box height */
  color: #485377;
  margin-bottom: 6px !important;
}

.content-body {
  padding-top: 10px;
}

.item {
  // font-family: 'Outfit';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  /* identical to box height */
  color: #485377;

}

.content {
  margin-bottom: 10px;
}

.divider-title {
  margin: 0;
  border: 1px solid #000000;
  margin-top: 5px;
}

.row .item {
  margin-top: 0 !important;
}

.v-data-table-header {
  background-color: #3751E4
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  color: white;
}
</style>